import type { SetupValue } from '../../data/types';

export type FieldKind =
  | 'text'
  | 'address'
  | 'textarea'
  | 'select'
  | 'switch'
  | 'date'
  | 'number'
  | 'colour'
  | 'staff';

export type SectionGroup = 'FUND' | 'CLASS' | 'ACTIVATE' | 'OFFER';

export interface SetupField {
  key: string;
  label: string;
  kind: FieldKind;
  options?: { value: string; label: string }[];
  required?: boolean;
  help?: string;
  toConfirm?: boolean;
  wide?: boolean;
  pattern?: { regex: RegExp; message: string };
  showIf?: (values: Record<string, SetupValue>) => boolean;
}

export interface FieldBlock {
  title: string;
  description?: string;
  fields: SetupField[];
  /** Fields per row from small screens up (two unless set). */
  columns?: number;
}

export const blockGridColumns = (columns = 2) => ({
  xs: '1fr',
  sm: `repeat(${columns}, minmax(0, 1fr))`,
});

export interface SetupSection {
  id: string;
  group: SectionGroup;
  title: string;
  summary: string;
  blocks: FieldBlock[];
}

export const GROUP_LABELS: Record<SectionGroup, string> = {
  FUND: 'Fund setup',
  CLASS: 'Unit class',
  ACTIVATE: 'Activate register',
  OFFER: 'Offer',
};

export const yesNo = (value: SetupValue | undefined) => value === true;
